import { Component, inject, OnInit } from '@angular/core';
import { PlanningHistoryEntry } from '../../../../classes/planning-history-entry';
import { User } from '../../../../classes/user.class';
import { AuthorisationService } from '../../../../services/auth/authorisation.service';
import { Features } from '../../../../services/auth/features';
import { PlanningService } from '../../../../services/planning/planning.service';
import { UserService } from '../../../../services/user/user.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-user-input',
    standalone: false,
    templateUrl: './user-input.component.html',
    styleUrl: './user-input.component.scss',
})
export class UserInputComponent extends InputComponent implements OnInit {
    private planningService = inject(PlanningService);
    private userService = inject(UserService);
    private latestProjectmanagerChange: PlanningHistoryEntry;
    users$ = this.userService.getByType(this.field.dataFilter as any[]);
    allUsers: User[] = [];

    get projectmanagerChange() {
        const controlProjectmanager = this.formData?.form.controls.planning.get('projectmanager');

        return this.fc === controlProjectmanager &&
            String(this.latestProjectmanagerChange?.old_value ?? '') !== String(this.fc.value ?? '')
            ? this.latestProjectmanagerChange
            : null;
    }

    ngOnInit(): void {
        this.subscriptions.add(this.userService.getList(true).subscribe(users => (this.allUsers = users)));

        const planningId = this.formData.orginal?.id;
        const control = this.formData.form.controls.planning.get('projectmanager');

        if (planningId && this.fc === control && AuthorisationService.hasFeature(Features.PlanningDetailHistory)) {
            this.subscriptions.add(
                this.planningService.getHistoryForField(planningId, 'projectmanager').subscribe(change => {
                    this.latestProjectmanagerChange = change;
                })
            );
        }
    }
}
